import React from "react";
import { Route, Routes } from "react-router";
import AllOeders from "../containers/admin/orders";
import AddNewOrder from "../containers/admin/orders/AddNewOrder";
import Dashboard from "../containers/admin";
import NdrOrders from "../containers/admin/orders/NdrOrders";
import PaymentVerification from "../containers/admin/orders/AddNewOrder/PaymentVerfication";
import ReportSection from "../containers/admin/orders/ReportSection";
import CodSection from "../containers/admin/orders/ReportSection/CodSection";
import PrepaidSection from "../containers/admin/orders/ReportSection/PrepaidSection";
import SalesSheet from "../containers/admin/orders/ReportSection/SalesSheet";

const userRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/orders" element={<AllOeders />} />
        <Route path="/orders/create-order" element={<AddNewOrder />} />
        <Route path="/ndrorders" element={<NdrOrders />} />
         <Route path="/reportsection" element={<ReportSection />} />
        <Route path="/payment-verification" element={<PaymentVerification />} />
        <Route path="/reportsectioncod" element={<CodSection />} />
        <Route path="/reportsectionprepaid" element={<PrepaidSection />} />
        <Route path="/reportsectionsales" element={<SalesSheet />} />
       
      </Routes>
    </div>
  );
};

export default userRoutes;
